import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
} from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { DisplayPdfFrameService } from "../../../../core/services/display-pdf-frame.service";
import { UrlToBase64 } from "../../../../core/models/shared/UrlToBase64Dto.model";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { PoEmailData } from "../../../../core/models/orders/PoEmailData";
import { LoaderService } from "../../../../core/services/loader.service";
import { EnumOrderEmailState } from "../../../../shared/enums/orderEmailState.enum";
import { CommonService } from "../../../../core/services/common.service";
import { CommonModule } from "@angular/common";
import { SelectChangeEvent, SelectModule } from "primeng/select";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { pdfDefaultOptions } from "ngx-extended-pdf-viewer";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { CheckboxModule } from "primeng/checkbox";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";

@Component({
  selector: "jni-display-pdf-frame",
  templateUrl: "./display-pdf-frame.component.html",
  styleUrls: ["./display-pdf-frame.component.scss"],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    SelectModule,
    NgxExtendedPdfViewerModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
    ButtonModule,
    CardModule,
  ],
})
export class DisplayPdfFrameComponent implements OnInit, OnChanges {
  @Input() displayRushRevisedSection = true;
  @Input() parent!: FormGroup;
  @Input() set templatesList(emailTemplates: EmailTemplates[]) {
    this.templates = emailTemplates;
    this.parent.patchValue({
      header: {
        templateId: this.templates[0]?.id,
      },
    });
  }
  @Input() poNumberRevision: string[] = [];
  @Output() emailSelectionEvent = new EventEmitter();
  @Input() poEmailData: PoEmailData = {} as PoEmailData;
  @Output() base64Pdf = new EventEmitter();
  templates: EmailTemplates[] = [];
  poJournalPdf = "";
  poNumber = "";
  windowState = 0;
  saleOrderId = "";
  displayPoSection = true;
  displaySaleOrderSection = false;
  @Input() isAnyUnCommitLines = false;
  @Input() modulewindowState = 0;
  @Output() refreshOrderLinesGrid = new EventEmitter();

  constructor(
    private _orderSummaryService: OrderSummaryService,
    private _loaderService: LoaderService,
    private _activatedRoute: ActivatedRoute,
    private _displayPdfFrameService: DisplayPdfFrameService,
    private _commonService: CommonService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.poNumber = params["poNumber"];
      this.windowState = params["windowState"] ?? 0;
      this.saleOrderId = params["id"];
    });
  }

  ngOnInit(): void {
    this.disabledpoNumber();
    this.getEmailPO();
    this.patchValueInPO();
    this.patchValueInSaleOrder();
    this.disabledSaleOrder();
    this.onPONumberSelection();

    if (
      this.windowState == EnumOrderEmailState.ProjectConfirmation ||
      this.windowState == EnumOrderEmailState.PrintOrderSummary ||
      this.windowState == EnumOrderEmailState.PrintProjectApproval
    ) {
      this.displayPoSection = false;
      this.displaySaleOrderSection = true;
    }
  }

  ngOnChanges(): void {
    if (this.poEmailData?.windowState) {
      this.saleOrderId = this.poEmailData.saleOrderId;
      this.poNumber = this.poEmailData.poNumber;
      this.windowState = this.poEmailData.windowState;
    }
  }

  onEmailSelection() {
    this.emailSelectionEvent.emit();
  }

  disabledpoNumber() {
    this.parent.get(["header", "poNumber"])?.disable();
  }

  disabledSaleOrder() {
    this.parent.get(["header", "saleOrderId"])?.disable();
  }

  patchValueInPO() {
    this.parent.patchValue({
      header: {
        poNumber: this.poNumber,
      },
    });
  }

  patchValueInSaleOrder() {
    this.parent.patchValue({
      header: {
        saleOrderId: this.saleOrderId,
      },
    });
  }

  getEmailPO() {
    this._loaderService.setLoaderState(true);

    if (this.windowState == EnumOrderEmailState.ProjectConfirmation) {
      this._orderSummaryService
        .printProjectConfirmation(this.saleOrderId)
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this._loaderService.setLoaderState(true);
              if (this.isAnyUnCommitLines) {
                // Refresh order lines grid
                this.refreshOrderLinesGrid.emit();
              }
              const convertTobase64Req: UrlToBase64 = {
                url: res.data,
                status: "",
                message: "",
                base64String: "",
              };

              this._commonService
                .ConvertUrlToBase64(convertTobase64Req)
                .subscribe({
                  next: resp => {
                    this._loaderService.setLoaderState(false);
                    if (resp?.status?.toLowerCase() == "success") {
                      this.poJournalPdf = resp.base64String?.toString();
                      this.base64Pdf.emit(this.poJournalPdf);
                    }
                  },
                  error: () => {
                    this._loaderService.setLoaderState(false);
                  },
                });
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    } else if (this.windowState == EnumOrderEmailState.PrintOrderSummary) {
      this._orderSummaryService
        .OrderSummaryDocument(this.saleOrderId)
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.poJournalPdf = res.data;
              this.base64Pdf.emit(this.poJournalPdf);
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    } else if (this.windowState == EnumOrderEmailState.PoPrinting) {
      this._orderSummaryService.printPOForSalesOrder(this.poNumber).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            if (res?.data) {
              this.poJournalPdf = res.data;
              this.base64Pdf.emit(this.poJournalPdf);
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
    } else if (this.windowState == EnumOrderEmailState.PrintProjectApproval) {
      this._orderSummaryService
        .printProjectApproval(this.saleOrderId)
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this._loaderService.setLoaderState(true);
              const convertTobase64Req: UrlToBase64 = {
                url: res.data,
                status: "",
                message: "",
                base64String: "",
              };

              this._commonService
                .ConvertUrlToBase64(convertTobase64Req)
                .subscribe({
                  next: resp => {
                    this._loaderService.setLoaderState(false);
                    if (resp?.status?.toLowerCase() == "success") {
                      this.poJournalPdf = resp.base64String?.toString();
                      this.base64Pdf.emit(this.poJournalPdf);
                    }
                  },
                  error: () => {
                    this._loaderService.setLoaderState(false);
                  },
                });
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    } else {
      this._orderSummaryService.printPOForSalesOrder(this.poNumber).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            if (res?.data) {
              this.poJournalPdf = res.data;
              this.base64Pdf.emit(this.poJournalPdf);
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
    }
  }

  onRushSelection(event: MouseEvent) {
    this._displayPdfFrameService.onRushSelection(event);
  }

  onRevisedSelection(event: MouseEvent) {
    this._displayPdfFrameService.onRevisedSelection(event);
  }

  onTemplateSelection(event: SelectChangeEvent) {
    this._displayPdfFrameService.onTemplatesSelection(event.value);
  }

  onPONumberSelection() {
    this._displayPdfFrameService.onPONumberSelection(this.poNumber);
  }

  getFileNameByModuleState() {
    if (this.windowState == EnumOrderEmailState.ProjectConfirmation) {
      return `ProjectConfirmation-${this.saleOrderId}`;
    } else if (this.windowState == EnumOrderEmailState.PrintOrderSummary) {
      return `OrderSummary-${this.saleOrderId}`;
    } else if (this.windowState == EnumOrderEmailState.PrintProjectApproval) {
      return `ProjectApproval-${this.saleOrderId}`;
    }

    return "document";
  }
}
